export default __webpack_public_path__ + "media/images/home/nl/preview-4-e5ef6b4601f98de644b287de6bb9a0b7.jpg";